import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {CalendarioChiusureAnnoRecord} from "@commons/mapping/CalendarioChiusureAnnoRecord";
import {DateTime} from "luxon";
import {IndiceMese} from "@commons/types";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export type TipoCalendario = 'GENERICO' | 'CHIUSURA_PRESENZE' | 'CHIUSURA_WF' | null; // Nell' ordine 0, 1 e 2

export interface CalendarioChiusureRecord extends URIAndTrace {
    idAzienda: number | null;
    idCalendario: number | null;
    tipoCalendario: TipoCalendario;
    descrizione: string | null;
    enabled: boolean;
    defaultXMonitorWF: boolean;
    anno: CalendarioChiusureAnnoRecord | null;
}

export class CalendarioChiusureRecord {
    static factory: ObjectFactory<CalendarioChiusureRecord> = (json?) => {

        return merge<CalendarioChiusureRecord, Partial<CalendarioChiusureRecord> | undefined>({
            idAzienda: null,
            idCalendario: null,
            tipoCalendario: null,
            descrizione: null,
            enabled: false,
            defaultXMonitorWF: false,
            anno: null,
            URI: null,
        }, json);

    }

    static getScadenza = function (calendario: CalendarioChiusureRecord, index: IndiceMese | null): DateTime | null {
        if (calendario && calendario.enabled && index !== null) {
            const date = (calendario.anno) ? CalendarioChiusureAnnoRecord.getScadenza(calendario.anno, index) : null;
            return date ? DateTime.fromISO(date) : null;
        }
        return null;
    }
}